export default __webpack_public_path__ + "0a4c6e665a2e44afe62909695829346d.png";